import { useEffect } from "react";
import { getSettings } from "../api";

/** Sets <title> and meta tags from CMS settings (seo_*). Mounted once at app root. */
export default function SEOHead() {
  useEffect(() => {
    let cancelled = false;
    getSettings().then((s) => {
      if (cancelled || !s) return;

      const setMeta = (selector, attr, value) => {
        if (!value) return;
        let el = document.head.querySelector(selector);
        if (!el) {
          el = document.createElement("meta");
          const [, name] = selector.match(/\[([^=]+)="([^"]+)"\]/) || [];
          if (name) el.setAttribute(name, selector.match(/="([^"]+)"\]/)[1]);
          document.head.appendChild(el);
        }
        el.setAttribute(attr, value);
      };

      if (s.seo_site_title) document.title = s.seo_site_title;
      setMeta('meta[name="description"]', "content", s.seo_meta_description);
      setMeta('meta[name="keywords"]', "content", s.seo_meta_keywords);
      setMeta('meta[property="og:title"]', "content", s.seo_site_title);
      setMeta('meta[property="og:description"]', "content", s.seo_meta_description);
      setMeta('meta[property="og:image"]', "content", s.seo_og_image);
      setMeta('meta[property="og:url"]', "content", s.seo_og_url);
      setMeta('meta[property="og:type"]', "content", "website");
      setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
      setMeta('meta[name="twitter:site"]', "content", s.seo_twitter_handle);
      setMeta('meta[name="twitter:title"]', "content", s.seo_site_title);
      setMeta('meta[name="twitter:description"]', "content", s.seo_meta_description);
      setMeta('meta[name="twitter:image"]', "content", s.seo_og_image);

      if (s.seo_favicon) {
        let link = document.head.querySelector('link[rel="icon"]');
        if (!link) {
          link = document.createElement("link");
          link.setAttribute("rel", "icon");
          document.head.appendChild(link);
        }
        link.setAttribute("href", s.seo_favicon);
      }
    });
    return () => { cancelled = true; };
  }, []);
  return null;
}
